import React, { useEffect } from "react";
import { Line } from "react-chartjs-2";

// Custom plugin to display "No data found" message
const noDataPlugin = {
  id: "noDataPlugin",
  afterDraw: (chart) => {
    const { datasets } = chart.data;
    let hasData = false;

    // Check if any dataset has data
    for (let i = 0; i < datasets.length; i++) {
      if (datasets[i].data.length > 0) {
        hasData = true;
        break;
      }
    }

    // If no data, display "No data found"
    if (!hasData) {
      const ctx = chart.ctx;
      const width = chart.width;
      const height = chart.height;

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "rgba(0, 0, 0, 0.8)";
      ctx.font = "16px Arial";
      ctx.fillText("No data found", width / 2, height / 2);
      ctx.restore();
    }
  },
};

const PhLimits = {
  waterPhLowerLimit: 6.5,
  waterPhHigherLimit: 8,
  coolnatPhLowerLimit: 8.5,
  coolnatPhHigherLimit: 11,
};

const LineChartComponent = ({
  dataInfo,
  labelData,
  // lowerLimitData = [],
  // higherLimitData = [],
  controlLineData,
  dataSet,
}) => {
  const dataSetName = dataSet || [];
  const highlightColor = "red"; // Color for highlighting points

  const waterlimitDataLower = new Array(controlLineData.length).fill(
    PhLimits.waterPhLowerLimit
  );
  const waterlimitDataHigher = new Array(controlLineData.length).fill(
    PhLimits.waterPhHigherLimit
  );
  const coolnatLimitDataHigher = new Array(controlLineData.length).fill(
    PhLimits.coolnatPhHigherLimit
  );
  const coolnatLimitDataLower = new Array(controlLineData.length).fill(
    PhLimits.coolnatPhLowerLimit
  );

  useEffect(()=>{
    console.log(`Controlline data:${controlLineData}`)
  },[controlLineData])

  function getDateLabels(date) {
    function formatDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    if (!date || date.length <= 0) {
      const dateLabels = [];
      const today = new Date();

      for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        const formattedDate = formatDate(date);
        dateLabels.push(formattedDate);
      }

      return dateLabels;
    } else {
      return date.map((d) => {
        const parsedDate = new Date(d);
        return formatDate(parsedDate);
      });
    }
  }

  function getHighlightedPoints(data, label) {
    return data.map((value) => {
      if (
        (label === "water" &&
          (value > PhLimits.waterPhHigherLimit ||
            value < PhLimits.waterPhLowerLimit)) ||
        (label !== "water" &&
          (value > PhLimits.coolnatPhHigherLimit ||
            value < PhLimits.coolnatPhLowerLimit))
      ) {
        return {
          backgroundColor: highlightColor,
          borderColor: highlightColor,
          radius: 2,
        };
      } else {
        return {
          backgroundColor: "rgb(0, 208, 255)",
          borderColor: "rgb(0, 208, 255)",
          radius: 2,
        };
      }
    });
  }

  const data = {
    labels: getDateLabels(labelData),
    datasets: [
      // Higher limit data for coolant
      {
        label: "Coolant PH Higher Limit",
        fill: false,
        borderColor: "purple",
        borderWidth: 1.5,
        // borderColor: "orange",
        data: coolnatLimitDataHigher,
        pointRadius: coolnatLimitDataHigher.length > 1 ? 0 : 3,
        pointHoverRadius: coolnatLimitDataHigher.length > 1 ? 0 : 3,
      },
      // Lower limit data coolant
      {
        label: "Coolant PH lower Limit",
        fill: false,
        borderColor: "purple",
        borderWidth: 1.5,
        // borderColor: "orange",
        data: coolnatLimitDataLower,
        pointRadius: coolnatLimitDataLower.length > 1 ? 0 : 3,
        pointHoverRadius: coolnatLimitDataLower.length > 1 ? 0 : 3,
        // pointBackgroundColor: getHighlightedPoints(lowerLimitData).map(point => point.backgroundColor),
        // pointBorderColor: getHighlightedPoints(lowerLimitData).map(point => point.borderColor),
        // pointRadius: getHighlightedPoints(lowerLimitData).map(point => point.radius)
      },
      // Higher limit data for water
      {
        label: "Water PH Higher Limit",
        fill: false,
        // borderColor: 'rgba(243, 114, 44, 1)',
        borderColor: "orange",
        borderWidth: 1.5,
        data: waterlimitDataHigher,
        pointRadius: waterlimitDataHigher.length > 1 ? 0 : 3,
        pointHoverRadius: waterlimitDataHigher.length > 1 ? 0 :3,
        // pointBackgroundColor: getHighlightedPoints(higherLimitData).map(point => point.backgroundColor),
        // pointBorderColor: getHighlightedPoints(higherLimitData).map(point => point.borderColor),
        // pointRadius: getHighlightedPoints(higherLimitData).map(point => point.radius)
      },
      // Lower limit data water
      {
        label: "Water PH lower Limit",
        fill: false,
        // borderColor: 'rgba(243, 114, 44, 1)',
        borderColor: "orange",
        borderWidth: 1.5,
        data: waterlimitDataLower,
        pointRadius: waterlimitDataLower.length > 1 ? 0 : 3,
        pointHoverRadius: waterlimitDataLower.length > 1 ? 0 : 3,
        // pointBackgroundColor: getHighlightedPoints(lowerLimitData).map(point => point.backgroundColor),
        // pointBorderColor: getHighlightedPoints(lowerLimitData).map(point => point.borderColor),
        // pointRadius: getHighlightedPoints(lowerLimitData).map(point => point.radius)
      },
      // Control line data
      {
        label: dataSetName[3] || "Control Line",
        fill: false,
        borderColor: "blue",
        borderWidth: 1.5,
        data: controlLineData || [],
        pointBackgroundColor: getHighlightedPoints(controlLineData).map(
          (point) => point.backgroundColor
        ),
        pointBorderColor: getHighlightedPoints(controlLineData).map(
          (point) => point.borderColor
        ),
        pointRadius: getHighlightedPoints(controlLineData).map(
          (point) => point.radius
        ),
      },
      // Main data set
      ...(dataInfo && dataInfo.length
        ? [
            {
              label: dataSetName[0] || "Main Data",
              fill: false,
              borderColor: "green",
              borderWidth: 1.5,
              data: dataInfo,
              pointBackgroundColor: getHighlightedPoints(dataInfo).map(
                (point) => point.backgroundColor
              ),
              pointBorderColor: getHighlightedPoints(dataInfo).map(
                (point) => point.borderColor
              ),
              pointRadius: getHighlightedPoints(dataInfo).map(
                (point) => point.radius
              ),
            },
          ]
        : []),
    ],
  };

  const options = {
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false, // Optionally hide tick marks on the axis
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
          ticks: {
            beginAtZero: true,
            stepSize: 1, // This ensures ticks appear at every integer
          },
        },
      ],
    },
    legend: {
      display: false,
      position: "bottom",
      labels: {
        usePointStyle: true,
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;

          return datasets.map((dataset, i) => ({
            text: dataset.label,
            fillStyle: dataset.borderColor,
            hidden: !chart.isDatasetVisible(i),
            lineCap: dataset.borderCapStyle,
            lineDash: dataset.borderDash,
            lineDashOffset: dataset.borderDashOffset,
            lineJoin: dataset.borderJoinStyle,
            strokeStyle: dataset.borderColor,
            pointStyle: "circle",
            datasetIndex: i,
          }));
        },
      },
      onClick: null, // Disable legend click
    },

    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };

  return (
    <div className="chart-wrapper custom-chart-wrapper">
      <Line data={data} plugins={[noDataPlugin]} options={options} />
    </div>
  );
};

export default LineChartComponent;
